import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { jsx as _jsx } from "react/jsx-runtime";
const ProgressTransferBanner = ({
  destinationEmail
}) => /*#__PURE__*/_jsx(Alert, {
  marginBlockEnd: "400",
  titleText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyCommon.myTeam.transferRequestSuccess.title"
  }),
  type: "info",
  children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "academyCommon.myTeam.transferRequestSuccess.body",
    options: {
      destinationEmail
    }
  })
});
export default ProgressTransferBanner;